<template>
  <div id="printable-content"></div>
</template>

<script>
import Sidebar from '@/components/Reports/Sidebar'
import ReportWrapper from '@/components/Reports/ReportWrapper'
import jsPDF from 'jspdf'
import * as jsPDFAutotable from 'jspdf-autotable'
import * as html2canvas from 'html2canvas'
import base64logo from '@/assets/images/base64logo.json'

export default {
  components: {
    Sidebar,
    ReportWrapper
  },
  props: {
    title: {
      type: String,
      default: () => 'Custom Report'
    },
    autoExport: {
      type: Boolean,
      default: () => true
    },
    downloadPdf: {
      type: Boolean
    },
    printReport: {
      type: Boolean
    }
  },
  data() {
    return {
      content: true,
      showReport: false,
      reportData: {},
      form: {},
      sensorData: {},
      pageWidth: 1024,
      tmLogo: base64logo.tm
    }
  },
  async mounted() {
    await this.setFormData(this.$route.query)
  },
  methods: {
    setFormData: function (params) {
      this.form = params
      this.getReportData()
    },
    updateSensorData(val) {
      this.sensorData = val
    },
    setLoadingState(val) {
      this.$emit('contentLoading', val)
    },
    pdfDownloaded(event) {
      this.$emit('pdfDownloaded', false)
    },

    generateReport() {
      try {
        window.html2canvas = html2canvas
        window.jsPDFAutotable = jsPDFAutotable
        const _this = this
        const html2canvas = require('html2canvas')
        const doc = new jsPDF({
          orientation: 'portrait',
          unit: 'pt',
          format: 'A4'
        })

        // Enable auto page wrap (there are still margin-top issues...)
        doc.context2d.pageWrapY = doc.internal.pageSize.height - 20

        var width = doc.internal.pageSize.getWidth()
        var height = doc.internal.pageSize.getHeight()
        var options = {
          width: width,
          pagesplit: true,
          margin: [50, 50, 40, 50]
        }

        // set page content width
        this.pageWidth = width

        // var printableContent = this.$refs.printableContent
        // var historicalItems = printableContent.$refs.historicalItems

        // // summary header
        // doc.internal.scaleFactor = 1;
        // doc.html(printableContent.$refs.contentHeader, options)

        // // loop historical  items
        // for (var items of historicalItems) {
        //   doc.addPage()
        //   doc.html(items, options)
        // }

        // this.addHeadersFooters(doc, width)
        // doc.save(`Report ${_this.form.reportType}.pdf`);

        // this.$emit('pdfDownloaded', false)
        // this.$message.success('PDF has been generated, please check your download folder :)')

        doc.html(this.$refs.printPdf, {
          width: width,
          pagesplit: true,
          margin: [50, 50, 40, 50],
          callback: function (pdf) {
            _this.addHeadersFooters(doc, width)

            doc.save(`Report ${_this.form.reportType}.pdf`)
            _this.$emit('pdfDownloaded', false)
            _this.$message.success(
              'PDF has been generated, please check your download folder :)'
            )
          }
        })
      } catch (err) {
        console.error('export-pdf', err)
        this.$message.error(
          'Something went wrong, please refresh the page to export Report data'
        )
        this.$emit('pdfDownloaded', false)
      }
    },
    addHeadersFooters(doc, width) {
      const pageCount = doc.internal.getNumberOfPages()
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        // doc.addImage(this.tmLogo, 'png', 15, 5, 71, 40)

        doc.setTextColor(0)
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(16)
        doc.text(`Report ${this.title}`, doc.internal.pageSize.width / 2, 35, {
          align: 'center'
        })

        doc.setFont('helvetica', 'italic')
        doc.setFontSize(8)
        doc.text(
          'Page ' + String(i) + ' of ' + String(pageCount),
          doc.internal.pageSize.width / 2,
          820,
          {
            align: 'center'
          }
        )
      }
    },
    currentDate() {
      var date = new Date()
      var day = date.getDate()
      var month = date.getMonth() + 1
      var year = date.getFullYear()

      return `${year}-${month}-${day}`
    },
    printNow() {
      window.html2canvas = html2canvas
      window.jsPDFAutotable = jsPDFAutotable
      const _this = this
      const html2canvas = require('html2canvas')
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'A4'
      })

      var width = doc.internal.pageSize.getWidth()
      var height = doc.internal.pageSize.getHeight()
      this.pageWidth = width
      doc.internal.scaleFactor = 1

      doc.html(this.$refs.printPdf, {
        width: width,
        pagesplit: true,
        margin: [50, 50, 40, 50],
        callback: function (pdf) {
          _this.addHeadersFooters(doc, width)
          _this.$emit('pdfDownloaded', false)

          // autoprint
          doc.autoPrint()
          //This is a key for printing
          doc.output('dataurlnewwindow')
        }
      })

      this.$emit('reportPrinted', false)
    },

    async getReportData() {
      try {
        this.showReport = false
        this.setLoadingState(true)

        const res = await this.$axios.post(
          this.$appInfo.api.formula.createMultipleReportFormula,
          this.form
        )
        this.reportData = {
          form: this.form,
          report: res.data
        }

        // set default ListFormulaData
        this.reportData.form.ListFormulaData = []
        this.setLoadingState(false)
        this.showReport = true
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
